export const enviroment =
  // eslint-disable-next-line no-undef
  process.env ? process.env.NODE_ENV : 'development';
